import React,{Component,Fragment} from 'react';
import './Home.css';
import icon1 from '../../../image/icon1.svg'
import icon2 from '../../../image/icon2.svg'
import icon3 from '../../../image/icon3.svg'
import logoblue from '../../../image/logoblue.png'
import phone from '../../../image/phone.png'
import N1 from '../../../image/1.svg'
import N2 from '../../../image/2.svg'
import N3 from '../../../image/3.svg'
import imageContent from '../../../image/image-content.png'
import icon4 from '../../../image/icon4.svg'
import icon5 from '../../../image/icon5.svg'
import icon6 from '../../../image/icon6.svg'
import icon7 from '../../../image/icon7AR.png'
import Oval from '../../../image/Oval.png'
import star from '../../../image/star.svg'
import Frame from '../../../image/Frame.svg'
import Footer from '../Components/Footer/Footer'
import {Link} from 'react-router-dom';

import ScrollableAnchor  from 'react-scrollable-anchor'
class Home extends Component{
   
componentDidMount(){
    document.documentElement.lang = 'ar';

}
handelHideNav = ()=>{
    if(window.screen.width<992 ){
        const btnNav = document.getElementById('btnNav');
    btnNav.click();
    }

}
    render(){
        document.title ="kayn"; 
        document.getElementsByTagName("META")[1].content="كاين | نقوم باختيار وتخزين وحزم وشحن وجمع أموالك. يتيح لك هذا التركيز على ما يهم حقًا: مضاعفة مبيعات التجارة الإلكترونية الخاصة بك ، وكسب المزيد من المال والاستمتاع بوقت فراغك في إنجاز أعمالك بواسطة فريق Kayn الخاص بنا!  ";
        document.documentElement.lang = 'ar';

        window.addEventListener('scroll', function (e) {
           if(document.getElementById('nav')){
            var nav = document.getElementById('nav');
            if (document.documentElement.scrollTop || document.body.scrollTop > window.innerHeight) {
                    nav.classList.add('colornav');
                    nav.classList.remove('colornav2');
                } else {
                    nav.classList.add('colornav2');
                    nav.classList.remove('colornav');
                }
           }
        });
                const url =window.location.pathname.split('/').slice(2).toString().replace(',', '/')
                
        return(
        <div className="home AppAR">
  
            <header>
                <div className='container'>
                <nav className="navbar navbar-expand-lg color-md fixed-top  colornav2" id="nav">
                        <div className="container">
                        <Link to="/AR/"><img className="logo" src={logoblue} alt="kayn"/></Link>       

                        <button className="navbar-toggler navbar-dark " type="button" id="btnNav" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>

                            <div className="collapse navbar-collapse List" id="navbarNav">
                                <ul className="navbar-nav ml-auto text-uppercase">
                                    <li className="nav-item active">
                                        <a className="nav-link" href="/AR/#Feautures" onClick={this.handelHideNav}>المميّزات<span className="sr-only">(current)</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="/AR/#Howitwork" onClick={this.handelHideNav}>آليّات العمل</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="/AR/#Reviews" onClick={this.handelHideNav}>التعليقات</a>
                                    </li>
                                    {(localStorage.getItem("userToken")?
                                    <Fragment>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/AR/Orders">الطلبات</Link>
                                    </li>
                                    <li className="nav-item">
                                    <Link className="nav-link" to={"/"+url}>EN</Link>
                                    </li>
                                    </Fragment>
                                    :(localStorage.getItem("AdminTokenKayn")?
                                    <Fragment>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/Admin/Orders">الطلابات</Link>
                                    </li>
                                    <li className="nav-item">
                                    <Link className="nav-link" to={"/"+url}>EN</Link>
                                    </li>
                                    </Fragment>
                                     :
                                     <Fragment>
                                     <li className="nav-item">
                                     <Link className="nav-link" to="/AR/SignUp">تسجيل</Link>
                                     </li>
                                     <li className="nav-item">
                                     <Link className="nav-link" to="/AR/SignIn">دخول</Link>
                                     </li>
                                     <li className="nav-item">
                                     <Link className="nav-link" to={"/"+url}>EN</Link>
                                     </li>
                                     </Fragment>))}
                                </ul>
                            </div>

                        </div>
                    </nav>
                    <div className="row">
                    <div className="col-lg-6   ">

                    </div>


                    <div className="col-lg-6 contant   ">
                    <h3 className="fontsize3 my-3 ">إبدأ معنا اليوم بالبيع ثلاث مرّات !أكثر</h3>
                    <p className="fontsize5 my-3 ">ضاعف طلبات تجارتك الإلكترونية من خلال إتمام عملية الشحن الخاصة بك عبر تطبيق الشحن الأكثر تقدمًا في مصر.</p>
                    <Link to="/AR/Signup" className="btn btn-light badge-pill my-3 p-3 px-5 border shadow  text-muted btnhome"  >سجل الان</Link>
                    </div>
                    </div>
                </div>
            </header>
            <ScrollableAnchor  id="Feautures">
            <section  className="feautures container"   >
                <div className="row mx-0  py-5">
                    <div className="col-md-4 text-center">
                        <div className="p-3 my-5 mx-3">
                            <img className="my-3" src={icon1} alt="ضاعف أرباحك"/>
                            <div>
                                <h3 className="fontsize4 my-2">ضاعف أرباحك</h3>
                                <p className="text-muted my-2">نحن نؤمن لم عملية الإختيار, التّخزين, الحزم, الشحن و جمع أموالك.ما يتيح لك التركيز على ما هو أهم حقّا.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4  text-center">
                        <div className="p-3 my-5 mx-3">
                            <img className="my-3" src={icon2} alt="وفر وقتك و راحة بالك"/>
                            <div>
                                <h3 className="fontsize4 my-2">وفر وقتك و راحة بالك</h3>
                                <p className="text-muted my-2">نحن نؤمن لم عملية الإختيار, التّخزين, الحزم, الشحن و جمع أموالك.ما يتيح لك التركيز على ما هو أهم حقّا.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4  text-center">
                        <div className="p-3 my-5 mx-3">
                            <img className="my-3" src={icon3} alt="تابع التقدمك المحرز "/>
                            <div>
                                <h3 className="fontsize4 my-2">تابع التقدمك المحرز </h3>
                                <p className="text-muted my-2">نحن نؤمن لم عملية الإختيار, التّخزين, الحزم, الشحن و جمع أموالك.ما يتيح لك التركيز على ما هو أهم حقّا.</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </section >
            </ScrollableAnchor>
            <section className="py-4">
                    <div className="container">
                        <div className="feauturesPick px-2">
                            <div className=" col-lg-7 mx-auto text-center">
                                    <h2 className="fontsize7">20٪ فقط من مجهوداتك ستظمن لك 80٪ من مبيعاتك  </h2>
                                    <p className="text-muted my-2">
                                    ضاعف مبيعاتك في التجارة الإلكترونية ، لكسب المزيد من المال والإستمتاع بوقت فراغك حين إنجاز أعمالك عبر الفريق الخاص بنا (kayn)!
                                    </p>
                            </div>
                            <div className="row mx-0 ">
                                <div className="col-lg-5 py-5 mt-3 px-0">
                                    <div className="row mx-0 my-4">
                                            <div className="col-3 mt-4 text-center">
                                            <img className="" src={N1} alt="feautures"/>
                                            </div>
                                            <div className="col-9 pl-0 pr-4">
                                                <h5 className=" my-3">قم بجدولة النقاط الخاصة بك/طلباتك</h5>
                                                <p className="text-muted my-2">قم بجدولة الأمر بسهولة في التطبيق الخاص بنا(هالبيل) إلى عتبة دارك لتجميع النقاط الخاصة بك/طلباتك بكل سرور</p>
                                            </div>
                                    </div>
                                    <div className="row mx-0 my-4">
                                            <div className="col-3 mt-4 text-center">
                                            <img className="" src={N2} alt="feautures"/>
                                            </div>
                                            <div className="col-9 pl-0 pr-4">
                                                <h5 className=" my-3">تابع عملية التّسليم الخاصة بك</h5>
                                                <p className="text-muted my-2">يتيح لك نظام التتبع المتقدم لدينا مراقبة تسليم المنتج الخاص بك في الوقت الحقيقي على كل خطوة من مسار البريد السريع.</p>
                                            </div>
                                    </div>
                                    <div className="row mx-0 my-4">
                                            <div className="col-3 mt-4 text-center">
                                            <img className="" src={N3} alt="feautures"/>
                                            </div>
                                            <div className="col-9 pl-0 pr-4">
                                                <h5 className=" my-3">إجني مالك بسهولة</h5>
                                                <p className="text-muted my-2">نجمع لك أي مدفوعات لمبيعاتك و نودعها مباشرة في حسابك لتسدد وقتما تشاء.</p>
                                            </div>
                                    </div>
                                </div>
                                <div className="col-md-7 pr-0 phone">
                                         <img className="mt-3" src={phone} alt="feautures"/>
                                </div>
                            </div>
                            <div className="moneyPick">
                                <div className="row">
                                    <div className="col-md-6 text-center imageContent">
                                    <img className="" src={imageContent} alt="feautures"/>

                                    </div>
                                    <div className="col-lg-5 py-md-4 ">
                                        <h3 className="fontsize7 my-4">لا تفوّت أي عمليّة بيع <br/>، قم دائما بخطوة إلى الأمام</h3>
                                        <p  className="text-muted my-2">نقوم باختيار وتخزين وحزم وشحن وجمع أموالك. يتيح لك هذا التركيز على ما يهم حقًا مضاعفة مبيعات التجارة الإلكترونية الخاصة بك ، وكسب المزيد من المال والاستمتاع بوقت فراغك في إنجاز أعمالك بواسطة فريق Kayn الخاص بنا!</p>
                                        <div className="row mx-0 text-center my-md-5 " >
                                            <div className="col-4">
                                                <p className="fontsize8 mb-0">10k</p>
                                                <h6 className="mx-2">تنزيل</h6>
                                            </div>
                                            <div className="col-4 p-0">
                                            <p className="fontsize8 mb-0">30k</p>
                                                <h6 className="mx-2">تعليقات ايجابيه</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>
            </section>
            <ScrollableAnchor  id="Howitwork">

            <section className="py-5 container" >
                    <div className="howitwork py-5" >
                        <div className="text-center col-md-8 mx-auto ">
                            <h2 className="fontsize7 ">كيف يعمل (Kayn)؟</h2>
                            <p className="text-muted my-2" >مستخدمينا نافذي الصبر، ربما يصرف انتباهكم. اجعلوها بسيطة وجميلة وممتعة وعملية.
 جماليات واضخة مدعومة بفكرة قوية هو ما نسعى عنه/ندافع عنه.</p>
                        </div>
                        <div className="row mx-0 py-5">
                            <div className="col-md-3 mx-2 px-0">
                                <div className=" text-center">
                                    <img className="my-3" src={icon6} alt="سجّل بسهولة<"/>                                    
                                    <div>
                                        <h3 className="fontsize4 my-2">سجّل بسهولة</h3>
                                        <p className="text-muted my-2">إشترك بسهولة وأمان بخطوة واحدة بسيطةثمّ سيتم تمكينك من إدارة حسابك.</p>
                                    </div>
                                 </div>
                            </div>
                            <div className="col-md-1  icon my-5 text-center p-0">
                                <img className="my-3" src={icon7} alt="arrow"/>                                    
                            </div>
                            <div className="col-md-3 mx-2 px-0">
                                <div className=" text-center">
                                    <img className="my-3" src={icon4} alt="إنشاء طلبك"/>                                    
                                    <div>
                                        <h3 className="fontsize4 my-2">إنشاء طلبك</h3>
                                        <p className="text-muted my-2">قم بجدولة ذلك وسنصل بكل سرور إلى عتبة بابك </p>
                                    </div>
                                 </div>
                            </div>
                            <div className="col-md-1 icon my-5 text-center p-0">
                                <img className="my-3" src={icon7} alt="arrow"/>                                    
                            </div><div className="col-md-3 mx-2 px-0">
                                <div className=" text-center">
                                    <img className="my-3" src={icon5} alt="أتمتة الشحن الخاص بك"/>                                    
                                    <div>
                                        <h3 className="fontsize4 my-2">أتمتة الشحن الخاص بك</h3>
                                        <p className="text-muted my-2">نقوم باختيار وتخزين وحزم وشحن وجمع أموالك. هذا يتيح لك التركيز على ما يهم.</p>
                                    </div>
                                 </div>
                            </div>
                            
                        </div>
                    </div>
            </section>
            </ScrollableAnchor>
            <ScrollableAnchor id="Reviews">
            <section className=" reviews py-5" >
                <div className="container py-3">
                <div className="col-md-7 text-center text-white mx-auto ">
                    <h2 className="fontsize7 my-3"> كم يحب العملاء خدمتنا</h2>
                    <p className="text-light">مستخدمينا نافذي الصبر، ربما يصرف انتباهكم. اجعلوها بسيطة وجميلة وممتعة وعملية.
 جماليات واضخة مدعومة بفكرة قوية هو ما نسعى عنه/ندافع عنه.</p>
                </div>
                <div className="col-md-6 mx-auto text-white py-4">
                        <div id="carouselExampleInterval" className="carousel slide" data-ride="carousel">
                            <div className="carousel-inner my-3">
                                <div className="carousel-item active" data-interval="10000">
                                    <div className="row">
                                        <div className="col-md-1 text-center">
                                            <img className="my-3" src={Oval} alt="user" />
                                        </div>
                                        <div className="col-md-10 m-3">
                                            <p className="font-italic">لقد بسّطتم عليّا الأمر. الشحن الخاص بي كان أسرع بكثير وأسهل في توصيل المنتج إلى عملائي.ما كان عليّ فقط هو إنشاء الحساب و هم اهتموا بكل المراحل الباقية. شكرا يا شباب!</p>
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <p className="font-weight-bold my-3">عبد الرحمن محمد</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-1 text-center">
                                            <img className="my-3" src={Oval} alt="user" />
                                        </div>
                                        <div className="col-md-10 m-3">
                                            <p className="font-italic">لقد بسّطتم عليّا الأمر. الشحن الخاص بي كان أسرع بكثير وأسهل في توصيل المنتج إلى عملائي.ما كان عليّ فقط هو إنشاء الحساب و هم اهتموا بكل المراحل الباقية. شكرا يا شباب!</p>
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <p className="font-weight-bold my-3">عبد الرحمن محمد</p>
                                        </div>
                                    </div>
                                        </div>
                                <div className="carousel-item" data-interval="2000">

                                    <div className="row">
                                        <div className="col-md-1 text-center">
                                            <img className="my-3" src={Oval} alt="user" />
                                        </div>
                                        <div className="col-md-10 m-3">
                                            <p className="font-italic">لقد بسّطتم عليّا الأمر. الشحن الخاص بي كان أسرع بكثير وأسهل في توصيل المنتج إلى عملائي.ما كان عليّ فقط هو إنشاء الحساب و هم اهتموا بكل المراحل الباقية. شكرا يا شباب!</p>
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <p className="font-weight-bold my-3">عبد الرحمن محمد</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-1 text-center">
                                            <img className="my-3" src={Oval} alt="user" />
                                        </div>
                                        <div className="col-md-10 m-3">
                                            <p className="font-italic">لقد بسّطتم عليّا الأمر. الشحن الخاص بي كان أسرع بكثير وأسهل في توصيل المنتج إلى عملائي.ما كان عليّ فقط هو إنشاء الحساب و هم اهتموا بكل المراحل الباقية. شكرا يا شباب!</p>
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <img className="" src={star} alt="star" />
                                            <p className="font-weight-bold my-3">عبد الرحمن محمد</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                           
                            <ol className="carousel-indicators ">
                                <li data-target="#carouselExampleInterval" data-slide-to="0" className="active"></li>
                                <li data-target="#carouselExampleInterval"  data-slide-to="1"></li>
                            </ol>
                        </div>         
                </div>
                </div>
            </section>
            </ScrollableAnchor>

          
            <section className="applynow   py-5">
                <div className="container">
                    <div className="row mx-0 py-5">
                        
                        <div className="col-lg-6  p-5 ">
                            <h2 className="fontsize7 text-white  my-5">هل لديك سيارة وتحتاج إلى مال إضافي؟</h2>
                            <p className="text-white my-5">إملأ الإستمارة بكل سهولة لتنظمّ !إلى (Kayn)  </p>
                            <Link to="/AR/Courier/Signup" className="btn btn-light badge-pill my-3 p-3 px-lg-5 border shadow  text-muted btnhome">سجل الآن</Link>
                        </div>
                        <div className="col-md-6 text-center Frame">
                            <img className="my-5" src={Frame} alt="Frame" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="installapp  py-5">
                <div className="container ">
                    <div className="row">
                        <div className="col-lg-6  text-center">

                        </div>

                        <div className="col-lg-6  text-center">
                            <h2 className="fontsize7   my-5">جرب (kayn) مجانًا</h2>
                            <p className="text-muted my-4">الشركات إن كانت كبيرة أو الصغيرة، عبر الإنترنت أو غير المتصلة، المحلية أو الدولية. .. الحجم لا يهم نحن نعمل على مشاريع متنوّعة لأفضل العلامات التجارية وكذلك للشركات الناشئة.يمكنك التّحقق من بعضها المفضّل لدينا.</p>
                            <p className="text-muted my-4">نقوم باختيار وتخزين وحزم وشحن وجمع أموالك. يتيح لك هذا التركيز على ما يهم حقًا: مضاعفة مبيعات التجارة الإلكترونية الخاصة بك ، وكسب المزيد من المال والاستمتاع بوقت فراغك في إنجاز أعمالك بواسطة فريق Kayn الخاص بنا!</p>

                            <Link to="/AR/Signup"  className="btn btn-light badge-pill my-3 p-3 px-5 border shadow  text-muted btnhome ">سجل الان</Link>
                        </div>
                    </div>
                </div>
            </section><hr className="m-0"/>
            <Footer/>
        </div>

        )
    }
}
export default Home;